// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Ripio */
export const Ripio = createBankIcon({
  name: "Ripio",
  slug: "ripio",
  compe: null,
  color: "#690ed8",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#690ED8;fill-opacity:1\"\n     id=\"ripio_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(-9.8555,-10.7910) scale(1.87097)\">\n    <path d=\"M44 38.7838L20 48V26.2162L44 17V38.7838Z\" style=\"fill:#ffffff\" />\n  </g>",
});
